import { Box, CircularProgress, Stack, styled, Typography } from '@mui/material';
import { HeaderClient } from '../FloorPlan/components/elements/HeaderClient';
import { useInjection } from './hook';

export const FloorPlanViewPage = () => {
  const { paths, handleBack, floorPlanUrl, isLoading } = useInjection();

  return (
    <WrapperFloorPlanPage>
      <HeaderClient
        searchholder="Search"
        title={paths.at(-1)?.name}
        textButton="Back"
        onClickButton={handleBack}
        paths={paths}
      />

      <ViewerCard>
        <FloorPlanViewer>
          {isLoading ? (
            <EmptyState>
              <CircularProgress
                size={36}
                sx={{
                  color: '#226AAA'
                }}
              />

              <Typography color="#6B7280">Loading floor plan...</Typography>
            </EmptyState>
          ) : floorPlanUrl ? (
            <ImageCanvas>
              <FloorPlanImage
                src={floorPlanUrl}
                alt={`${paths.at(-1) || 'Floor'} floor plan`}
                draggable={false}
              />
            </ImageCanvas>
          ) : (
            <EmptyState>
              <Stack alignItems="center" gap="4px">
                <Typography
                  sx={{
                    color: '#334155',
                    fontSize: '16px',
                    fontWeight: 600
                  }}>
                  Floor plan not available
                </Typography>

                <Typography
                  sx={{
                    color: '#6B7280',
                    fontSize: '14px'
                  }}>
                  No floor plan has been uploaded for this location.
                </Typography>
              </Stack>
            </EmptyState>
          )}
        </FloorPlanViewer>
      </ViewerCard>
    </WrapperFloorPlanPage>
  );
};

const WrapperFloorPlanPage = styled(Stack)(() => ({
  width: '100%',
  height: '100vh',
  padding: '40px 30px 30px 40px',
  gap: '10px',
  overflow: 'hidden'
}));

const ViewerCard = styled(Stack)(() => ({
  width: '100%',
  minHeight: 0,
  flex: 1,
  overflow: 'hidden',
  border: '1px solid #E4E7EC',
  borderRadius: '8px',
  backgroundColor: '#FFFFFF'
}));

const FloorPlanImage = styled('img')(() => ({
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  objectPosition: 'center',
  userSelect: 'none',
  boxShadow: '0 4px 18px rgba(15, 23, 42, 0.12)',
  backgroundColor: '#FFFFFF'
}));

const ImageCanvas = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  minWidth: 0,
  minHeight: 0,
  padding: '20px'
}));

const FloorPlanViewer = styled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  width: '100%',
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
  backgroundColor: '#F7F8FA'
}));

const EmptyState = styled(Stack)(() => ({
  width: '100%',
  height: '100%',
  minHeight: '350px',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px'
}));
